import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule, FormControl, Validators, UntypedFormArray, UntypedFormBuilder, ValidatorFn } from '@angular/forms';
import { PhoneType } from 'src/app/models/problem';

const validatePhone: ValidatorFn = (fg: UntypedFormGroup) => {
  const phoneType = fg.get('phoneType').value;
  const phoneNum = fg.get('phoneNum').value;

  let isValid = true;
  if (phoneNum !== null && phoneNum !== '') {
    if (phoneType === null || phoneType === '') {
      isValid = false;
    }
  }

  if (phoneType !== null && phoneType !== '') {
    if (phoneNum === null || phoneNum === '') {
      isValid = false;
    }
  }

  return isValid ? null : { phoneInvalid: true };
};

@Component({
    selector: 'app-addcase-contact',
    templateUrl: './addcase-contact.component.html',
    styleUrls: ['./addcase-contact.component.scss'],
    standalone: false
})
export class AddcaseContactComponent implements OnInit {

  @Input() fg: UntypedFormGroup;
  @Input() phoneTypes: PhoneType[];

  get phoneArr() {
    return this.fg.get('phoneSection').get('phoneNumArray') as any;
  }

  constructor(
    private formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit() {
    // add one field to phoneNum arrays
    if (this.phoneArr.length === 0) {
      this.phoneArr.push(this.formBuilder.group({
        phoneNum: '',
        phoneType: ''
      }, { validator: validatePhone }));
    }
  }

  addPhoneFields() {
    this.phoneArr.push(this.formBuilder.group({
      phoneNum: '',
      phoneType: '',
    }, { validator: validatePhone }));
    this.fg.markAsDirty();
  }

  removePhoneField(idx: number) {
    this.phoneArr.removeAt(idx);
    this.fg.markAsDirty();
  }

  clearPhoneType(fg: UntypedFormGroup) {
    const phoneNum = fg.get('phoneNum').value;
    if (phoneNum === '') {
      fg.get('phoneType').setValue(null);
    }
  }
}
